import api from './api';

export const vendorService = {
  getVendors: (params) => api.get('/vendors/', { params }),
  getVendor: (id) => api.get(`/vendors/detail/?id=${id}`),
};
